import { useEffect, useRef } from 'react'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

export default function useCheckUnderControl() {
  const pageConfig = usePageConfig()
  const hasChecked = useRef(false)

  useEffect(() => {
    if (hasChecked.current || !pageConfig) {
      return
    }

    const { isUnderControl, currentUserProfile, currentUserUsername } = pageConfig

    window.checkIfUnderControl?.(isUnderControl, currentUserProfile, currentUserUsername)
    hasChecked.current = true
  }, [pageConfig])
}
